import Vue from "vue";

import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import storage from "./components/utils/storage";
import i18n from "./i18n";
import "./filters/datetime";
import "@fortawesome/fontawesome-free/css/all.css";
import "typeface-roboto";

Vue.config.productionTip = false;

Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value),
});

(async function applyRuntimeLocalesOverride() {
  try {
    const res = await fetch("/locales/es.json", { cache: "no-cache" });
    if (res.ok) {
      const overrideEs = await res.json();
      const currentEs = i18n.getLocaleMessage("es") || {};
      const merged = (function deepMerge(target, source) {
        if (typeof target !== "object" || target === null) return source;
        if (typeof source !== "object" || source === null) return target;
        const out = Array.isArray(target) ? target.slice() : { ...target };
        for (const key of Object.keys(source)) {
          const sv = source[key];
          const tv = out[key];
          if (Array.isArray(sv)) {
            out[key] = sv.slice();
          } else if (typeof sv === "object" && sv !== null) {
            out[key] = deepMerge(
              typeof tv === "object" && tv !== null ? tv : {},
              sv
            );
          } else {
            out[key] = sv;
          }
        }
        return out;
      })(currentEs, overrideEs);

      i18n.setLocaleMessage("es", merged);
      if (i18n.locale === "es") {
        i18n.locale = "es";
      }
      console.log("Override de /locales/es.json aplicado");
    } else {
      console.log(
        "No hay override en /locales/es.json (status:",
        res.status,
        ")"
      );
    }
  } catch (err) {
    console.warn("Error cargando override /locales/es.json:", err);
  }
})();

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.log("Service Worker registrado con éxito:", registration.scope);
        storage.saveSwStatus("true");
      })
      .catch((error) => {
        console.error("Error registrando Service Worker:", error);
        storage.saveSwStatus("false");
      });
  });
}
